import template from './net-sales-game-list.html';

export default {
  template,
  bindings: {
    games: '<',
    label: '<',
    header: '<',
    netSalesTotal: '<',
    locale: '<',
  },
};



// WEBPACK FOOTER //
// ./src/modules/dashboard/components/dashboard-widget/net-sales/components/net-sales-game-list/net-sales-game-list-component.js